<template>
  <div class="footer-wraper">
    <div class="auto-box company" v-if="!isSimple">
      <div class="item">
        <div class="lable">医护继续教育</div>
        <div class="flex">
          <div class="pointer" @click="toUrl('BASEHOME')">
            <img
              class="img"
              src="@/assets/PC/footLogoerke.png"
              width="25"
              height="25"
              alt=""
            />
            国家基层儿科医护人员培训项目
          </div>
          <div style="margin: 0 50px" class="pointer" @click="toUrl('NERVE')">
            <img
              src="@/assets/PC/nao.png"
              class="img"
              width="25"
              height="25"
              alt=""
            />
            国家神经疾病医护人员培训平台
          </div>
          <div class="pointer" @click="toUrl('BXB')">
            <img
              class="img"
              src="@/assets/PC/footLogoerke.png"
              width="25"
              height="25"
              alt=""
            />儿童白血病定点医院培训平台
          </div>
        </div>
      </div>
      <div class="item">
        <div class="lable">研究院</div>
        <div>
          <div class="pointer" @click="toUrl('THEME_PM')">
            <img
              class="img"
              src="@/assets/PC/yuanmologo.png"
              width="25"
              height="25"
              alt=""
            />精准医学研究与产业发展
          </div>
        </div>
      </div>
      <div class="item">
        <div class="lable">常用工具</div>
        <div>
          <div class="pointer">
            <a-popover placement="top">
              <template #content>
                <img
                  src="@/assets/PC/wechatApp.jpg"
                  width="120"
                  height="120"
                  alt=""
                />
              </template>
              <img
                class="img"
                src="@/assets/PC/yaowuzhushou.png"
                width="25"
                height="25"
                alt=""
              />药如指掌
            </a-popover>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="auto-box">
        <div class="bottom">
          <p>
            Copyright © 2020-{{ new Date().getFullYear() }} 上海源墨健康有限公司
            版权所有
          </p>
          <div class="icp-box"></div>
          <p class="center">
            <a target="_blank" href="https://beian.miit.gov.cn/"
              >沪ICP备2020032025号-1</a
            >
          </p>
          <div class="icp-box">
            <img src="@/assets/PC/icp.png" class="icp" />
            <p>
              <a
                href="https://beian.mps.gov.cn/#/query/webSearch?code=31010902103695"
                ref="noreferrer"
                target="_blank"
                >沪公网安备 31010902103695</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
// import { useRouter } from "vue-router";
import { getJumpUrl, getJumpUrlPC } from "@/utils/help";
export default defineComponent({
  setup() {
    // const router = useRouter();
    // 简版个人中心
    const isSimple = ref(sessionStorage.getItem("isSimple"));

    const toUrl = async (name) => {
      let urlPath = name == "BXB" ? await getJumpUrlPC(name) : getJumpUrl(name);
      window.open(urlPath);
    };
    return {
      toUrl,
      isSimple,
    };
  },
});
</script>

<style scoped lang="less">
.footer-wraper {
  background: #2f3135;
}
.company {
  padding: 24px 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  .item {
    width: 800px;
    align-self: center;
    display: flex;
    margin-bottom: 15px;

    .lable {
      width: 76px;
      align-self: flex-start;
      margin-right: 15px;
    }
    .img {
      margin-right: 6px;
    }
  }
}
.footer {
  padding: 30px 0;
  height: 80px;
  background: #242529;
  .top {
    margin: 0 250px;
    display: flex;
    justify-content: space-between;
    .item {
      display: flex;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      line-height: 22px;
      .img {
        width: 42px;
        height: 42px;
        margin-right: 12px;
      }
      .gzh {
        width: 62px;
        height: 62px;
        margin-right: 12px;
      }
      p {
        margin: 0;
      }
    }
    .phone {
      margin-left: 100px;
    }
  }
  .bottom {
    width: 800px;
    display: flex;
    // margin-left: 280px;
    justify-content: space-between;
    margin: 0 auto;
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
    .center {
      margin: 0 50px;
      a {
        color: #999999;
      }
    }
    .icp-box {
      display: flex;
      a {
        color: #999999;
      }
    }
    .icp {
      width: 18px;
      height: 20px;
      margin-right: 12px;
    }
  }
}
</style>
